/**
 * 君が探してるのはdashboard.action.tsかもしれないよ？
 */
import {Action} from '@ngrx/store';
import {Update} from '@ngrx/entity';
import {QueryParamsModel} from '../_base/crud';
import {ProjectModel} from '../models/project.model';

export enum ProjectActionTypes {
    UPDATE_PROJECT = '[Project Feature] Emit to update the project',
    PROJECT_UPDATED = '[Project Feature] Emitted after the project has been updated',
    DELETE_PROJECT = '[Project Feature] Emitted after one project has been deleted',
    LOAD_PROJECT = '[Project Feature] Emit to load a project',
    PROJECT_LOADED = '[Project Feature] Emitted after a project has been loaded',
    LOAD_PROJECTS = '[Project Feature] Emit to load a list of projects',
    CANCEL_LOAD_PROJECTS = '[Project Feature] Emit to cancel loading a list of projects',
    PROJECTS_LOADING = '[Project Feature] True while the projects are being loaded',
    PROJECTS_LOADED = '[Project Feature] Emitted after a list of projects has been loaded',
    PROJECTS_BUSY = '[Project Feature] True while an action on the project list is running',
    CLEAR_PROJECTS = '[Project Feature] Emit to clear the project',
    UPDATE_PROJECT_IS_READ = '[Project Feature] update project is read or not'
}

export class UpdateProjectAction implements Action {
    readonly type = ProjectActionTypes.UPDATE_PROJECT;

    constructor(public payload: {
        partialProject: Update<ProjectModel>,
        project: ProjectModel,
        mobileNotificationData: any, token?: string }) {
    }
}

export class ProjectUpdatedAction implements Action {
    readonly type = ProjectActionTypes.PROJECT_UPDATED;

    constructor(public payload: { project: ProjectModel }) {
    }
}

export class DeleteProjectAction implements Action {
    readonly type = ProjectActionTypes.DELETE_PROJECT;

    constructor(public payload: { id: number }) {
    }
}

export class LoadProjectAction implements Action {
    readonly type = ProjectActionTypes.LOAD_PROJECT;

    constructor(public payload: { id: number , token?: string | null}) {
    }
}

export class ProjectLoadedAction implements Action {
    readonly type = ProjectActionTypes.PROJECT_LOADED;

    constructor(public payload: { project: ProjectModel }) {
    }
}

export class LoadProjectsAction implements Action {
    readonly type = ProjectActionTypes.LOAD_PROJECTS;

    constructor(public payload: { page: QueryParamsModel<ProjectModel> }) {
    }
}

export class CancelLoadProjectsAction implements Action {
    readonly type = ProjectActionTypes.CANCEL_LOAD_PROJECTS;
}

export class ProjectsLoadingAction implements Action {
    readonly type = ProjectActionTypes.PROJECTS_LOADING;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class ProjectsLoadedAction implements Action {
    readonly type = ProjectActionTypes.PROJECTS_LOADED;

    constructor(public payload: {
        projects: ProjectModel[],
        isReadStatus: any,
        totalCount: number,
        totalPrice: number | undefined }) {
    }
}

export class ProjectsBusyAction implements Action {
    readonly type = ProjectActionTypes.PROJECTS_BUSY;

    constructor(public payload: { isLoading: boolean }) {
    }
}

export class ClearProjectsAction implements Action {
    readonly type = ProjectActionTypes.CLEAR_PROJECTS;
}
export type ProjectActions = UpdateProjectAction
    | ProjectUpdatedAction
    | DeleteProjectAction
    | LoadProjectAction
    | ProjectLoadedAction
    | LoadProjectsAction
    | CancelLoadProjectsAction
    | ProjectsLoadingAction
    | ProjectsLoadedAction
    | ProjectsBusyAction
    | ClearProjectsAction;
    
